var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(value) {
  return this.__data__.set(value, HASH_UNDEFINED), this;
}
export {
  setCacheAdd as default
};
//# sourceMappingURL=_setCacheAdd.js.map
